import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const BatchChildWorkflowSchema_ = z.object({
  workflowId: z.string(),
  status: z.enum(["running", "completed", "failed", "unknown"]),
  startTime: z.string().nullable(),
});
export interface BatchChildWorkflowSchema
  extends z.infer<typeof BatchChildWorkflowSchema_> {}
export const BatchChildWorkflowSchema: z.ZodType<BatchChildWorkflowSchema> =
  BatchChildWorkflowSchema_;

const BatchAeoJobInfoSchema_ = z.object({
  workflowId: z.string(),
  status: z.enum(["running", "completed", "failed", "unknown"]),
  startTime: z.string().nullable(),
  children: z.array(BatchChildWorkflowSchema),
});
export interface BatchAeoJobInfoSchema
  extends z.infer<typeof BatchAeoJobInfoSchema_> {}
export const BatchAeoJobInfoSchema: z.ZodType<BatchAeoJobInfoSchema> =
  BatchAeoJobInfoSchema_;

export const getBatchAeoJobStatus = unaryRpc({
  name: "getBatchAeoJobStatus",
  input: z.object({}),
  output: z.object({ batches: z.array(BatchAeoJobInfoSchema) }),
});
